import AuthActions from '/b2b/authentication/state/Auth.actions';
import { signOut as SignOutService } from '/b2b/authentication/services';

export const signOut = () => dispatch => {
    SignOutService();
    dispatch(AuthActions.logout());
};
